import React from 'react';

import './search-widget.css';
import classNames from 'classnames';

interface SearchWidgetContainerProps {
  headline?: string;
  subline?: string;
  inverseText?: boolean;
  children: React.ReactNode;
}

const defaultProps: Pick<SearchWidgetContainerProps, 'headline' | 'subline' | 'inverseText'> = {
  headline: undefined,
  subline: undefined,
  inverseText: false,
};

function Headline({
  headline,
  inverseText,
}: {
  headline: string;
  inverseText: boolean;
}): JSX.Element | null {
  if (headline) {
    return <h2 className={classNames('title', { 'title--inverse': inverseText })}>{headline}</h2>;
  }
  return null;
}

function Subline({
  subline,
  inverseText,
}: {
  subline: string;
  inverseText: boolean;
}): JSX.Element | null {
  if (subline) {
    return (
      <h2 className={classNames('sub-title', { 'sub-title--inverse': inverseText })}>{subline}</h2>
    );
  }
  return null;
}

const SearchWidgetContainer = React.forwardRef<HTMLDivElement, SearchWidgetContainerProps>(
  ({ headline, subline, children, inverseText }, ref): JSX.Element => (
    <div className="search-widget" ref={ref}>
      <Headline headline={headline || ''} inverseText={inverseText || false} />
      <Subline subline={subline || ''} inverseText={inverseText || false} />
      {children}
    </div>
  ),
);

SearchWidgetContainer.defaultProps = defaultProps;

export default SearchWidgetContainer;
